import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserReportAddModel, UserReportModel } from '@digilize/shared/definitions/src';

/** Errors a user reports from the alert bar (PAUL-3344); each report opens a ticket in the service desk. */
@Injectable({ providedIn: 'root' })
export class UserReportsApiService {
  readonly USER_REPORTS_URL = '/api/v1.0/user-reports';

  constructor(private http: HttpClient) {}

  addReport(report: UserReportAddModel) {
    return this.http.post<UserReportModel>(this.USER_REPORTS_URL, report);
  }
}
